'use strict';

var elementCtrl = ["graphDataFactory", "$scope", 'NgMap', '$state', '$serverData', function (graphDataFactory, $scope, NgMap, $state, $serverData) {
    var _this = this;
    _this.mapInit = false;
    _this.markers = [];
    _this.bounds = new google.maps.LatLngBounds();
    _this.mapObject = 'map-'.concat(_this.element.id);
    $scope.apiKey = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB2qCMNBGF2_-S5gTVHnA7K76nLB8VNYgg';
    
    let height;
    if (_this.element.heightMode === 'percentage' && _this.element.heightPercentage !== undefined) {
        let percentage = parseFloat(_this.element.heightPercentage) || 100;
        percentage = Math.max(0, Math.min(100, percentage));
        height = window.innerHeight * percentage / 100;
    } else {
        let parts = parseFloat(_this.element.partsOfWindowHeight) || 1;
        height = window.innerHeight / parts;
    }
    _this.height = height;

    _this.cssPanel = "height:".concat((_this.height - 15).toFixed(), "px;")

    // Se crea una sola instancia de InfoWindow para reutilizarla
    const infoWindow = new google.maps.InfoWindow();

    _this.centerMap = ()=>{
        NgMap.getMap(_this.mapObject).then(function (map) {
            map.setCenter(_this.bounds.getCenter());
        });
    }

    _this.resetMap = function () {
        NgMap.initMap(_this.mapObject);
        NgMap.getMap(_this.mapObject).then(function (map) {
            _this.setMarkers(map).then(() => {
                map.setCenter(_this.bounds.getCenter());
            });
            document.getElementById(_this.mapObject).style.height = "".concat((_this.height - 56), "px");
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    _this.loadData = () => {
        let forceUpdateData = false;
        return graphDataFactory.getData(_this.element.templateData.datasourceElementId, forceUpdateData)
            .then(data => {
                // console.log('data', data)
                return data.reduce((lst, item) => {
                    let pos = {};
                    if (item[_this.element.templateData.columnCoords]) {
                        if (item[_this.element.templateData.columnCoords] && item[_this.element.templateData.columnCoords] != ",") {
                            if (item[_this.element.templateData.columnCoords] != ",") {
                                let coords = item[_this.element.templateData.columnCoords].split(",");
                                pos.idName = _this.element.templateData.idReport || "ID";
                                pos.idItem = item[pos.idName];
                                pos.title = "".concat(item[_this.element.templateData.columnName] || "N/A");
                                pos.coords = new google.maps.LatLng(coords[0], coords[1]);
                                if (Array.isArray(pos.title))
                                    console.log(item[pos.idName], pos.title);
                                lst.push(pos);
                            }
                        }
                    }
                    return lst;
                }, []);
            });
    }

    _this.setBounds = (bounds, positions) => {
        positions.forEach(function (position) {
            bounds.extend(position.coords);
        });
    }

    _this.setMarkers = (map) => {
        if (_this.markers.length) {
            _this.markers.forEach(function (marker) {
                marker.setMap(null);
            });
        }
        _this.markers = [];
        return _this.loadData().then(positions => {
            _this.setBounds(_this.bounds, positions);
            positions.map(position => {
                const marker = new google.maps.Marker({
                    position: position.coords, title: position.title,
                    map: map,
                    draggable: false,
                    animation: google.maps.Animation.DROP
                });
                if (position.idItem) {
                    const linkUrl = `${$serverData.server}/departments/${$state.params.departmentId}/forms/0/html/${position.idItem}`;
                    const infoWindowContent = `
                        <div style="min-width: 100px; min-height: 30px;">
                            <a target="_blank" href="${linkUrl}" style="text-decoration: none; color: inherit; font-size: 16px; outline: none;">
                                <img style="height: 30px; vertical-align: middle; margin-right: 5px;" src="https://field.voolks.com/app/images/icons/textarea.png">
                                ${position.title}
                            </a>
                        </div>
                    `;
                    marker.addListener('click', () => {
                        infoWindow.setContent(infoWindowContent);
                        infoWindow.open(map, marker);
                    });
                }
                _this.markers.push(marker);
            });
        });
    }

    $scope.$on('graph-reloadData', function (event, forceUpdateData) {
        _this.resetMap();
    });

    // console.log('_this.element', _this.element)
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            onChange: '&'
        },
        replace: true,
        controller: elementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graph-view/graphMapViewDirective.html',
        link: function (scope) {
            scope.ctrl.resetMap();
        }
    };
};